/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-24 17:14:47
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-24 17:21:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorButton/Preview/index.tsx
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { getButtons } from '../slice';
import Button from './Button';
import styles from './style.less';

function Preview() {
  const buttons = useSelector(getButtons());
  return (
    <div className={styles.container}>
      {buttons.map((button) => {
        return (
          <div className={styles.buttonContainer} key={button.uuid}>
            <Button button={button} />
          </div>
        );
      })}
    </div>
  );
}

export default Preview;
